import { useContext } from 'react'
import { AppDispatch } from './Model'
import restaurantFrontDoor from './assets/restaurant-front-door.webp'
import glazedAntiqueJug from './assets/glazed-brown-antique-milk-jug.webp'
import marbleBustWithFlag from './assets/marble-statue-bust-in-front-of-italian-flag.webp'
import christmasStar from './assets/christmas.webp'

export function OurStory() {
	return (
		<div className='announcement'>
			<h1>Our Story</h1>
			<h2>Established in 2013</h2>
			<p>The first Castello restaurant was opened in 2013 by three guys with 15 years of tradition and experience in the restaurant business. Passionate about authentic food made with only the very best ingredients, everything at Castello is inspired by Italy and its traditions and values.</p>
			<p>We all work hard to find the very best ingredients for all of our dishes. Our suppliers share our ethos and take enormous pride in what they do. </p>
			<p>Castello captures what makes Italians most proud: fantastic rustic dishes, using recipes that are loved! The menu is full of authenticity, and is driven by what you’d find people eating all over Italy.</p>
		</div>
	)
}

export function TheResturant() {
	return (
		<div className='announcement'>
			<h1>The Restaurant</h1>
			<h2>Friendly, warm environment</h2>
			<p>An evening at Castello isn't just about the food, although that is of course fabulous. It is about a feeling of welcome and love and passion. You will want to come again bringing your friends and family to share in the experience. </p>
			<p>We train our staff to have a deep knowledge of all the dishes we serve. We teach our staff the origin of each dish and how the dishes have been created and cooked.</p>
			<p>We are the “Italian table” – where people can relax, share and enjoy each other’s company – our menu is packed full of antipasti and nibbles, perfect for sharing, as well as comforting bowls of pasta, beautiful fresh salads and grills.</p>
		</div>
	)
}

export function Parties() {
	return (
		<div className='announcement'>
			<h1>Parties</h1>
			<h2>All ages welcome</h2>
			<p>Castello is accessible and affordable. We are a neighbourhood restaurant where everyone is welcome and feels comfortable, no matter the time of day.</p>
			<p>If you are organising a party, a family gathering or planning an event, give us a call. Our restaurants have beautiful spaces that are ideal for special occasions. </p>
			<p>Whatever the event, whether a kids' birthday party, a business event – we've got it covered.</p>
		</div>
	)
}

export default function AnnouncementGrid() {
	const dispatch = useContext(AppDispatch)
	
	return (
		<div className='announcement-grid'>
			<a href='/uploads/Menus/Castello Christmas Party Menu 2026.png'>
				<img src={christmasStar} alt='Christmas star' />
				<h5>Christmas 2026</h5>
			</a>
			<button onClick={() => dispatch({ type: 'announcement', value: 'our-story' })}>
				<img src={glazedAntiqueJug} alt='Glazed brown antique milk jug' />
				<h5>Our Story</h5>
			</button>
			<button onClick={() => dispatch({ type: 'announcement', value: 'the-restaurant' })}>
				<img src={restaurantFrontDoor} alt='Castello restaurant front door' />
				<h5>The Restaurant</h5>
			</button>
			<button onClick={() => dispatch({ type: 'announcement', value: 'parties' })}>
				<img src={marbleBustWithFlag} alt='Marble statue bust in front of Italian flag' />
				<h5>Parties</h5>
			</button>
		</div>
	)
}
